// Generated by scripts/gen-standard-page-translations.mjs. Do not edit.
import type { CoreLanguageType } from 'shared/src/types/languages.type';
import type { NotFoundUiContent } from '../not-found-ui-content';
import { notFound as lang_bn } from './bn/not-found';
import { notFound as lang_ca } from './ca/not-found';
import { notFound as lang_cy } from './cy/not-found';
import { notFound as lang_eu } from './eu/not-found';
import { notFound as lang_ga } from './ga/not-found';
import { notFound as lang_gd } from './gd/not-found';
import { notFound as lang_gl } from './gl/not-found';
import { notFound as lang_hi } from './hi/not-found';
import { notFound as lang_mi } from './mi/not-found';
import { notFound as lang_mr } from './mr/not-found';
import { notFound as lang_rm } from './rm/not-found';
import { notFound as lang_ta } from './ta/not-found';
import { notFound as lang_te } from './te/not-found';

export const notFoundTranslations: Partial<Record<CoreLanguageType, NotFoundUiContent>> = {
  'bn': lang_bn,
  'ca': lang_ca,
  'cy': lang_cy,
  'eu': lang_eu,
  'ga': lang_ga,
  'gd': lang_gd,
  'gl': lang_gl,
  'hi': lang_hi,
  'mi': lang_mi,
  'mr': lang_mr,
  'rm': lang_rm,
  'ta': lang_ta,
  'te': lang_te,
};
